import type { FaireProductEntity } from "../../entity_types/product";

export const p_w86su3d6cx: FaireProductEntity = {
  token: "p_w86su3d6cx",
  type: "product",
  name: "18K Gold PVD Stainless Steel Rhinestone Bow Charm",
  brandToken: "b_99ch5ye698",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d08317013b6b2b385117c8abd6f84c9e600d78b48c74c42694af89805c2588be.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/21cd87afb808bee9f78367d866ed09196af6f4f1b070de6295d71e31508a559b.jpeg",
    "https://cdn.faire.com/fastly/4dfa202bf05eb32bba7bf538fd2d49d7a31128eadf7f4f02f4e0913316751deb.jpeg",
    "https://cdn.faire.com/fastly/9ffe549172abf7981bba916c245fbbab18319cb589d4e5e1c8d08d9e33d7f1e1.jpeg",
    "https://cdn.faire.com/fastly/198ffb8a125ed66c237102018de0f53fe1a301177bc658e0fa35e190fee63cb9.jpeg",
    "https://cdn.faire.com/fastly/01473921561ac182dcf3143191a4e9bff1923f7b72d2f97f39607213db7d3d34.jpeg",
    "https://cdn.faire.com/fastly/c2f749f31851d036456a088fed20a9c2c8d24118b3252d036a1be980655b581b.jpeg",
    "https://cdn.faire.com/fastly/e664b4b07d8045a1e5af48462e6e47b942935dabfbf678c2e4d74b3d05484d46.jpeg",
    "https://cdn.faire.com/fastly/7615168bf5f22de08715c2402def0dec791bc8add29f61d262381706a033c128.jpeg",
    "https://cdn.faire.com/fastly/284fa02b5228dda4b544c1ebafa93813d1ec99b5ce88a9a4439dc6464d8c1811.jpeg",
    "https://cdn.faire.com/fastly/7015ccca45bd70972d272ea6c3509ae6fbcd174112fc891435894a0e2d7abb28.jpeg",
    "https://cdn.faire.com/fastly/be3bdcdac720290b8153d03b38e8d549da56f204a1ac4aa75322a7ac8d7cd80b.jpeg",
    "https://cdn.faire.com/fastly/ae482591f60b9acbaabae40cb76d517f64283eced0211c738523e58833fca0c6.jpeg",
    "https://cdn.faire.com/fastly/986cd3b55235149b37cc2903ef64b2c8ae89522f19b106dd207268e93e91f471.jpeg",
    "https://cdn.faire.com/fastly/624f7ed57305375c66e718364095ed7ff83397e586d5eccc24ae887b38a60a4c.jpeg",
    "https://cdn.faire.com/fastly/067addf1e68e643acd0d1a0c13ae82e095a987fc1eebcc6675d7da0d1ad78a5d.jpeg",
  ],
  priceDollars: 9.7,
  description:
    'Delicate yet dazzling, this Bow Charm with stunning rhinestone accents is the perfect blend of femininity and modern edge. Designed off the major coquette and whimsey trend, this charm is an instant best seller. Embellished with shimmering rhinestones, this charm adds a touch of brilliance to any jewelry collection—whether worn on a bracelet, necklace, wire earrings or bag chain!\n\n• A must have for charm bars!\n• Premium 18K Gold PVD stainless steel\n• 100% Waterproof, non-tarnish, hypoallergenic \n• The perfect add on charm to bracelets, necklaces, and wire earrings\n• Charm Size: 14mm x 15.8mm (0.55" x 0.62")\n• Jump Ring: 3mm, 21 gauge\n\nPro Tip: Pair this charm with our best selling charm holder necklaces!\n\nWe use the process of PVD Coating our 18K Gold jewelry over 316L surgical grade stainless steel for a non-tarnish, hypoallergenic, finish that will hold up best to everyday wear and will never turn skin green.\n\n➜ Same day shipping from Destin, FL before 3PM CST.',
  tags: [],
  msrpDollars: 19.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:46.779Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
